import { AuthAPI } from '../auth/api/AuthAPI';
import { FilterContentFieldDataTypes } from '../filter/constants';
import { Filter } from '../filter/interface';
import { DESTINATION_FILTER } from '../pipelines/constants/pipeline-filters';

export const PIPELINE_SUBSCRIPTIONS_FILTERS: Filter[] = [
  DESTINATION_FILTER,
  {
    title: 'Created by',
    filterKey: 'created_by',
    filterType: FilterContentFieldDataTypes.LIST,
    filterContentProps: {
      multiple: true,
      dataSource: () =>
        AuthAPI.getMembers().then(res =>
          res.data
            .filter((member: { is_hidden: boolean }) => !member.is_hidden)
            .map((member: { display_name: string; id: number }) => ({
              label: member.display_name,
              value: member.id
            }))
        ),
      textFieldProps: {
        forceActiveLegend: true,
        prefixIcon: 'search',
        placeholder: 'Search'
      }
    }
  }
];
